import { useCallback, useEffect, useLayoutEffect, useState } from "react";
import Sidebar from "../../components/dashboard/Sidebar";
import Navbar from "../../components/dashboard/Navbar";
import email from "../../assets/images/email.svg";
import arrowLeft from "../../assets/images/next-pre.svg";
import { useNavigate, useSearchParams } from "react-router-dom";
import Overview from "../../components/dashboard/Tabs/Overview/Overview";
import Students from "../../components/dashboard/Tabs/Students/Students";
import Grades from "../../components/dashboard/Tabs/Grades/Grades";
import Settings from "../../components/dashboard/Tabs/Settings/Settings";
import { show as getClass } from "../../Store/api/professor/dashboard";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { ModalPortal } from "../../components/ModalPortal";
import { CustomModal } from "../../shared/CustomModal";
import { toast } from "react-toastify";
import { addSection } from "../../Store/api/classApi";

const ClassDetails = () => {
  const { classId } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [load, setLoad] = useState(false);
  const [refetch, setRefetch] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const { activetab } = useSelector((state) => state.ui.tabs);
  const [searchParams, setSearchParams] = useSearchParams({ currentTab: activetab });
  const currTab = searchParams.get("currentTab");
  const [classDetail, setClassDetail] = useState({
    sections: [],
    classData: { allActivityAnswers: [], allActivities: [] },
  });
  const [section, setSection] = useState({
    name: "",
    email: "",
    section_number: "",
  });
  const currentDate = new Date();
  let dateAfterSeven = new Date(currentDate);
  dateAfterSeven.setDate(currentDate.getDate() + 7);

  useLayoutEffect(() => {
    setLoad(true);
    dispatch(
      getClass({
        id: classId,
        onSuccess: (res) => {
          setLoad(false);
          setClassDetail(res.data.data);
        },
        onError: () => {
          setLoad(false);
        },
      })
    );
  }, [classId, dispatch]);

  useEffect(() => {
    setIsLoading(true);
    dispatch(
      getClass({
        id: classId,
        onSuccess: (res) => {
          setClassDetail(res.data.data);
          setIsLoading(false);
        },
        onError: () => {
          setIsLoading(false);
        },
      })
    );
  }, [classId, dispatch, currTab, refetch]);

  const setClassSettingProperties = (prop, value) => {
    setClassDetail((old) => {
      return {
        ...old,
        classData: {
          ...old.classData,
          [prop]: value,
        },
      };
    });
  };

  const onToggle = useCallback(() => setShowModal((prev) => !prev), []);

  const primary_instructor =
    classDetail?.sections
      ?.map((item) => item?.instructorEmails?.filter((item) => item.isPrimary))
      ?.flat(2)
      ?.map((item) => item.email) ?? [];
  const instructors =
    classDetail?.AdditionalInstructors?.map(
      (item) => `${item.firstName} ${item.lastName}`
    ) || [];

  const handleChange = (e) => {
    setSection((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const onAction = () => {
    if (!section.name) {
      toast.error("Section name required");
      // setError(prev => ({...prev, name: 'Section name required'}));
      return;
    } else if (!section.section_number) {
      toast.error("Section number required");
      // setError(prev => ({...prev, section_number: 'Section number required'}));
      return;
    }
    setLoading(true);
    dispatch(
      addSection({
        body: {
          classId,
          sectionName: section.name,
          instructorEmails: [section?.email || ""],
          sectionNumber: section.section_number,
        },
        onSuccess: () => {
          setRefetch(true);
          toast.success("Section added successfully.");
        },
        onError: () => {
          toast.error("Error while adding new section in class.");
        },
        onEnd: () => {
          setLoading(false);
          setSection({
            name: "",
            section_number: "",
            email: "",
          });
          setShowModal(false);
        },
      })
    );
  };

  const dueNextActivities = classDetail?.classData.allActivities.filter(
    (activity) => {
      const assignedDate = new Date(activity.assignedDate).setHours(0, 0, 0, 0); // Normalize time to midnight
      const currentDate = new Date().setHours(0, 0, 0, 0); // Normalize time to midnight

      // Check if activity is past due and has ungraded answers
      return (
        assignedDate >= currentDate && // Past due date
        activity?.activityAnswers?.some(
          (answer) =>
            (!answer.isGraded && answer.answers.length > 0) ||
            (answer.activityStatus === "InProgress" &&
              answer.answers.length > 0)
        )
      );
    }
  );

  const pastDueActivities = classDetail?.classData.allActivities.filter(
    (activity) => {
      const assignedDate = new Date(activity.assignedDate).setHours(0, 0, 0, 0); // Normalize time to midnight
      const currentDate = new Date().setHours(0, 0, 0, 0); // Normalize time to midnight

      // Check if activity is past due and has ungraded answers
      return (
        assignedDate < currentDate && // Past due date
        (!activity.activityAnswers.length ||
          activity.activityAnswers.some(
            (answer) =>
              !answer.isGraded && // Not graded
              (!answer.answers.length || // No answers
                (answer.answers.length &&
                  answer.activityStatus === "InProgress"))
          ))
      );
    }
  );
  const submittedDueActivities = classDetail?.classData.allActivities.filter(
    (activity) => {
      return activity?.activityAnswers?.some(
        (answer) =>
          answer.answers &&
          answer.answers.length > 0 &&
          answer.activityStatus !== "InProgress"
      );
    }
  );

  // Log the length of past-due activities

  return (
    <>
      <ModalPortal>
        <CustomModal
          loading={loading}
          onHide={onToggle}
          onAction={onAction}
          showModal={showModal}
          cancelBtnText="Go back"
          actionBtnText="Add section"
          title="add new section to class"
        >
          <div className="d-flex flex-column gap-2 w-100">
            <div className="d-flex justify-content-between">
              <div className="form-group mb-0 w-47">
                <input
                  type="text"
                  name="name"
                  value={section.name}
                  onChange={handleChange}
                  className="form-control"
                  placeholder="Section Name"
                />
                {/* {error.name && <span className="error-msg-3">*Section name required</span>} */}
              </div>
              <div className="form-group mb-0 w-47">
                <input
                  type="text"
                  name="section_number"
                  className="form-control"
                  placeholder="Section Number"
                  value={section.section_number}
                  onChange={handleChange}
                />
                {/* {error.section_number && <span className="error-msg-3">*Section number required</span>} */}
              </div>
            </div>
            <div className="form-group mb-0 w-100">
              <input
                type="email"
                name="email"
                value={section.email}
                onChange={handleChange}
                className="form-control mb-2"
                placeholder="Enter instructor email"
              />
              <p className="mb-0 text_grey fs-12 fw-normal lh-normal fst-normal">
                *We’ll send the instructor an email inviting them to join
                Greyled
              </p>
            </div>
          </div>
        </CustomModal>
      </ModalPortal>
      <div className="wrapper">
        <Sidebar userType="teacher" sideBarEvent={"classes"} />
        <div id="content">
          <div className="content_dashborad_inner ps-0">
            <Navbar sideBarEvent="classes" />
            <div className="main_section_content">
              <div className="center_content full_width pt-4">
                <div className="class_header gap-2">
                  {load ? (
                    <h4 className="content-skeleton m-0 mb-3"></h4>
                  ) : (
                    <>
                      <img
                        className="cursor class_back"
                        src={arrowLeft}
                        alt="arrow-left"
                        onClick={() => navigate("/dashboard/classes")}
                      />
                      <h5 className="ft_24">
                        {classDetail.classData.courseName}{" "}
                        {classDetail.classData.courseNumber}
                      </h5>
                    </>
                  )}
                </div>
                <div className="class_details_page_header cursor_default">
                  <div className="user_info_wrapper">
                    {load ? (
                      <h4 className="content-skeleton m-0 mb-3"></h4>
                    ) : (
                      <h3 className="class_sub_header">
                        {classDetail.sections.length} sections |{" "}
                        {classDetail.classData.numberOfStudents} students
                      </h3>
                    )}
                    <div className="class_info_wrapper">
                      <p className="fts__14 fw-semibold">Primary Instructor</p>
                      {load ? (
                        <h4 className="content-skeleton m-0"></h4>
                      ) : (
                        <p className="fts__14 text-lowercase">
                          {primary_instructor.join(", ")}
                          {primary_instructor.length > 0 &&
                            primary_instructor && (
                              <a
                                href={`https://mail.google.com/mail/?view=cm&fs=1&to=${primary_instructor}`}
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                <img
                                  style={{
                                    marginLeft: "12px",
                                    cursor: "pointer",
                                  }}
                                  src={email}
                                  alt="email"
                                  className="class_email greened"
                                />
                              </a>
                            )}
                        </p>
                      )}
                    </div>
                    <div className="class_info_wrapper">
                      <p className="fts__14 fw-semibold">Instructors</p>
                      {load ? (
                        <h4 className="content-skeleton m-0"></h4>
                      ) : (
                        <p className="fts__14 text-capitalize">
                          {instructors.join(", ")}
                        </p>
                      )}
                    </div>
                  </div>
                  <div className="classes_header_right_content_box">
                    <div className="class_activities_info">
                      <p className="fts__14 left_head fw-700">Activities</p>
                      <div className="class_activities_details w-100">
                        {load ? (
                          <h4 className="content-skeleton w-50 m-0"></h4>
                        ) : (
                          <>
                            <p className="fts__14 text-lowercase">
                              <b className="bld">
                                {
                                  classDetail?.classData?.allActivityAnswers?.filter(
                                    (x) => x.isGraded
                                  ).length
                                }
                                /
                                {
                                  classDetail?.classData?.allActivityAnswers
                                    ?.length
                                }{" "}
                              </b>
                              completed
                            </p>
                            <p className="fts__14 text-lowercase">
                              <b className="bld">{dueNextActivities.length}</b>{" "}
                              due in next 7 days
                            </p>
                            <p className="fts__14 text-lowercase">
                              <b className="bld">
                                {submittedDueActivities.length}{" "}
                              </b>
                              submitted{" "}
                            </p>
                            <p className="fts__14 text-lowercase">
                              <b className="bld">{pastDueActivities.length}</b>{" "}
                              past due
                            </p>
                          </>
                        )}
                      </div>
                    </div>
                    <div className="total_box_price">
                      {load ? (
                        <div className="d-flex justify-content-center">
                          <h4 className="content-skeleton m-0"></h4>
                        </div>
                      ) : (
                        <h1 className="ft_40">
                          {Math.round(
                            classDetail?.classData?.allActivityAnswers
                              ?.filter((x) => x.isGraded)
                              .reduce(
                                (acc, next) =>
                                  acc +
                                  (next.answers.length
                                    ? next.answers.reduce(
                                        (a, b) =>
                                          a +
                                          (b.hasOwnProperty("grade")
                                            ? b.grade
                                            : 0),
                                        0
                                      )
                                    : 0),
                                0
                              ) /
                              classDetail?.classData?.allActivityAnswers?.filter(
                                (x) => x.isGraded
                              ).length
                          ) || "--"}
                          %
                        </h1>
                      )}
                      <p className="ft_Cumulative  mt_32">cumulative Grade</p>
                    </div>
                  </div>
                </div>
                <div className="class_details">
                  <div className="custom_nav classes_cutsom_nav">
                    <ul
                      className="nav nav-tabs nav-justified"
                      id="myTab"
                      role="tablist"
                    >
                      <li className="nav-item" role="presentation">
                        <button
                          className={
                            currTab === "overview"
                              ? "nav-link active"
                              : "nav-link"
                          }
                          id="home-tab"
                          data-bs-toggle="tab"
                          data-bs-target="#overview"
                          type="button"
                          role="tab"
                          aria-controls="overview"
                          aria-selected="true"
                          onClick={(e) => {
                            setIsLoading(true);
                            setSearchParams({ currentTab: "overview"})
                          }}
                        >
                          overview
                        </button>
                      </li>
                      <li className="nav-item" role="presentation">
                        <button
                          className={
                            currTab === "grades"
                              ? "nav-link active"
                              : "nav-link"
                          }
                          id="classroom-tab"
                          data-bs-toggle="tab"
                          data-bs-target="#classroom"
                          type="button"
                          role="tab"
                          aria-controls="profile"
                          aria-selected="false"
                          onClick={(e) => {
                            setIsLoading(true);
                            setSearchParams({ currentTab: "grades"})
                          }}
                        >
                          grades
                        </button>
                      </li>
                      <li className="nav-item" role="presentation">
                        <button
                          className={
                            currTab === "students"
                              ? "nav-link active"
                              : "nav-link"
                          }
                          id="students-tab"
                          data-bs-toggle="tab"
                          data-bs-target="#students"
                          type="button"
                          role="tab"
                          aria-controls="students"
                          aria-selected="false"
                          onClick={(e) => {
                            setIsLoading(true);
                            setSearchParams({ currentTab: "students"})
                          }}
                        >
                          students
                        </button>
                      </li>
                      <li className="nav-item" role="presentation">
                        <button
                          className={
                            currTab === "settings"
                              ? "nav-link active"
                              : "nav-link"
                          }
                          id="settings-tab"
                          data-bs-toggle="tab"
                          data-bs-target="#settings"
                          type="button"
                          role="tab"
                          aria-controls="settings"
                          aria-selected="false"
                          onClick={(e) => {
                            setIsLoading(true);
                            setSearchParams({ currentTab: "settings"})
                          }}
                        >
                          settings
                        </button>
                      </li>
                    </ul>
                    {["overview", "settings"].includes(currTab) &&
                    isLoading ? (
                      "Loading..."
                    ) : (
                      <>
                        {(currTab === 'overview') && (
                          <Overview
                            classDetail={classDetail}
                            currentDate={currentDate}
                            dateAfterSeven={dateAfterSeven}
                            submittedDueActivities={submittedDueActivities}
                            dueNextActivities={dueNextActivities}
                          />
                        )}
                        {currTab === "settings" && (
                          <Settings
                            classId={classId}
                            setRefetch={setRefetch}
                            setClassDetail={setClassDetail}
                            setClassSettingProperties={
                              setClassSettingProperties
                            }
                            classSettings={classDetail.classData}
                            classSections={classDetail.sections}
                          />
                        )}
                      </>
                    )}
                    {currTab === "grades" && (
                      <Grades
                        classId={classId}
                        sections={classDetail.sections}
                        onToggle={onToggle}
                      />
                    )}
                    {currTab === "students" && (
                      <Students
                        classId={classId}
                        setRefetch={setRefetch}
                        classDetail={classDetail.classData}
                      />
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ClassDetails;
